import { useEffect, useRef, useState } from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  horizontal: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    "flex-direction": "column",
    "align-items": "stretch",
    "justify-content": "space-evenly",
    "pointer-events": "none",

    "& div": {
      opacity: props => (props.hidden ? 0.1 : 0.7),
      transition: "opacity 0.2s ease",
      "border-bottom": "1px solid #ccc",
    },
  },
  vertical: {
    extend: "horizontal",
    "flex-direction": "row",

    "& div": {
      opacity: props => (props.hidden ? 0.1 : 0.7),
      transition: "opacity 0.2s ease",
      "border-bottom": "none",
      "border-right": "1px solid #ccc",
    },
  },
});

const HorizonLines = ({ horizonOffset }) => {
  const [hidden, setHidden] = useState(true);
  const classes = useStyles({ hidden });
  const timeoutRef = useRef();
  const firstRef = useRef(true);

  useEffect(() => {
    if (firstRef.current) {
      firstRef.current = false;
    } else {
      let timeout = timeoutRef.current;
      setHidden(false);
      timeout = setTimeout(() => setHidden(true), 3000);
      return () => clearTimeout(timeout);
    }
  }, [horizonOffset]);

  return (
    <>
      <div className={classes.horizontal}>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
      <div className={classes.vertical}>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </>
  );
};

export default HorizonLines;
